/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Part_UnnamedInputs */

const en_ticket_part_unnamed = /** @type {(inputs: Ticket_Part_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unnamed part`)
};

const ja_ticket_part_unnamed = /** @type {(inputs: Ticket_Part_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名称不明の部品`)
};

const fr_ticket_part_unnamed = /** @type {(inputs: Ticket_Part_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pièce sans nom`)
};

const de_ticket_part_unnamed = /** @type {(inputs: Ticket_Part_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbenanntes Teil`)
};

/**
* | output |
* | --- |
* | "Unnamed part" |
*
* @param {Ticket_Part_UnnamedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_part_unnamed = /** @type {((inputs?: Ticket_Part_UnnamedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Part_UnnamedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_part_unnamed(inputs)
	if (locale === "ja") return ja_ticket_part_unnamed(inputs)
	if (locale === "fr") return fr_ticket_part_unnamed(inputs)
	return de_ticket_part_unnamed(inputs)
});